import { computed } from 'vue';

export default function useEChartDarkTheme() {
  const defaultTextColor = computed(() => 'rgba(255, 255, 255, 0.8)');
  const defaultLabelColor = computed(() => '#ACACAC');
  const theme = computed(() => ({
    animationDuration: 1000,
    animationEasing: 'cubicOut',
    backgroundColor: 'rgba(42, 46, 51, 1)',
    textStyle: {
      fontFamily: "'Exo', 'Noto Sans SC', sans-serif",
      fontSize: 12,
    },
    toolbox: {
      emphasis: {
        // Having default styles for toolbox
        iconStyle: {
          borderColor: defaultLabelColor.value,
          textFill: defaultLabelColor.value,
        },
      },
    },
    // Legend
    legend: {
      inactiveColor: '#808080',
      itemGap: 20,
      left: 'center',
      orient: 'horizontal',
      padding: [0, 20, 20, 20],
      pageIconColor: '#aaa',
      pageIconInactiveColor: '#2f4554',
      pageTextStyle: {
        color: defaultTextColor.value,
      },
      show: true,
      textStyle: {
        color: defaultTextColor.value,
        fontSize: 11,
      },
      top: 10,
    },
    // xAxis general settings
    categoryAxis: {
      axisLabel: {
        color: defaultLabelColor.value,
      },
      axisTick: { alignWithLabel: true },
    },
    // yAxis general settings
    valueAxis: {
      axisLine: {
        show: false, // Hides the yAxis line
      },
      axisTick: {
        show: false, // Hides the ticks
      },
      axisLabel: {
        show: true,
        color: defaultLabelColor.value,
      },
      // Lines that separate yAxis intervals
      splitLine: {
        show: true,
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.05)',
          type: 'solid',
        },
      },
    },
    // Styles on bars
    bar: {
      itemStyle: {
        borderRadius: [2, 2, 0, 0], // Rounded top corners
      },
    },
    // Styles on tooltips
    tooltip: {
      axisPointer: {
        type: 'shadow',
      },
      confine: false,
      appendTo: 'body',
      backgroundColor: 'rgba(33, 36, 39, 1)',
      borderWidth: 0,
      textStyle: {
        color: '#fff',
      },
    },
    // Styles on lines
    line: {
      symbol: 'circle',
      symbolSize: 5,
    },
    // Styles on pies
    pie: {
      radius: ['35%', '60%'],
      center: ['50%', '50%'],
      label: {
        show: true,
        alignTo: 'labelLine',
        color: defaultTextColor.value,
        position: 'outer',
        fontSize: 11,
      },
      labelLine: {
        show: true,
        length: 10,
        length2: 10,
        lineStyle: {
          color: defaultTextColor.value,
          width: 1.5,
        },
      },
    },
  }));

  return { theme };
}
